import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { mediaQueryMobileLimit } from '../../../../../utils/constants';

export const CustomerDataFormStyled = {
  Container: styled(Grid)<any>`
    display: flex;
    padding: 30px 30px 0px 30px;
    width: 100%;
    justify-content: space-between;
  `,
  Separator: styled.div<any>`
    margin-top: 15px;
  `,
  ContainerButton: styled.div<any>`
    display: flex;
    justify-content: center;
    @media (min-width: ${mediaQueryMobileLimit}px) {
      width: 20%;
    };
    align-self: center;
    margin: 0 30px 30px 30px;
    @media (min-width: ${mediaQueryMobileLimit}px) {
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 30px;
    };
  `,
  ContainerItemGrid: styled(Grid)<any>`
  `,
};
